import { Component, Prop, h, Host } from '@stencil/core';

const COMPONENT_NAME = 'sn-disclaimer-type-2';

/**
 * Integration disclaimer section with centered heading, description, and a dashed note box.
 * Used on SignNow integration pages to note that a specific integration is not yet available.
 * Dashed box contains a book icon (CSS ::after) with customizable note text via the slot.
 *
 * @product signnow
 * @version 1.0.0
 * @category SignNow
 * @contentConfig Integration disclaimer with heading, description paragraph, and "Please note" dashed-border box
 * @slot heading - {required}, <me-heading variant="2"> - Section heading above the description
 * @slot description - <me-text tag="p"> - Centered description paragraph
 * @slot note - <me-text tag="p"> - Content inside the dashed note box (include bold "Please note:" inline)
 * @example
 *   <sn-disclaimer-type-2>
 *     <me-heading slot="heading" variant="2">Consolidate your tools to maximize productivity</me-heading>
 *     <me-text slot="description" tag="p">Integrate airSlate SignNow functionality with your favorite software to minimize daily paperwork hassles and improve cooperation with clients, partners, and colleagues</me-text>
 *     <me-text slot="note" tag="p"><strong>Please note: </strong>The airSlate SignNow integration with Reesio is not available yet. We have created this page to find out whether the integration is in demand among our users. Once confirmed, we will add it as soon as possible. Please reach out to us for updates on the status of the integration.</me-text>
 *   </sn-disclaimer-type-2>
 */
@Component({
  tag: 'sn-disclaimer-type-2',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SnDisclaimerType2 {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  render() {
    return (
      <Host data-color-mode={this.colorMode}>
        <section class={COMPONENT_NAME}>
          <div class={`${COMPONENT_NAME}__container`}>
            <div class={`${COMPONENT_NAME}__inner`}>
              <div class={`${COMPONENT_NAME}__heading`}>
                <slot name="heading"></slot>
              </div>
              <div class={`${COMPONENT_NAME}__description`}>
                <slot name="description"></slot>
              </div>
              <div class={`${COMPONENT_NAME}__note-box`}>
                <slot name="note"></slot>
              </div>
            </div>
          </div>
        </section>
      </Host>
    );
  }
}
